module.exports = __webpack_public_path__ + "img/btn_quanpin.3377f33f.png";